import { View } from "@react-pdf/renderer";
import { tableBorder, tableHeaderBackground } from "./const";
import { SmallTextPDF, TableHeader } from "./Texts";

export function HeaderRow({
  label,
  fixed,
  renderLabel,
  style,
}: {
  label?: string;
  // When `fixed` is true, this header repeats on every page that the
  // wrappable parent occupies. Use together with `renderLabel` to vary the
  // label per page (e.g. add a "— continued" suffix on continuation pages).
  fixed?: boolean;
  renderLabel?: (info: {
    pageNumber: number;
    totalPages: number;
    subPageNumber: number;
    subPageTotalPages: number;
  }) => string;
  style?: any;
}) {
  return (
    <Row
      wrap={false}
      fixed={fixed}
      style={{
        backgroundColor: tableHeaderBackground,
        ...style,
      }}
    >
      {renderLabel ? (
        <TableHeader render={renderLabel} />
      ) : (
        <TableHeader>{label}</TableHeader>
      )}
    </Row>
  );
}

export function Row({
  children,
  last = false,
  style,
  wrap,
  fixed,
}: {
  children: React.ReactNode;
  last?: boolean;
  style?: any;
  // `wrap` and `fixed` pass through to the underlying react-pdf <View>. We
  // accept them so callers can mark a row atomic (wrap={false}) or repeat it
  // on each page of a wrappable parent (fixed). When not set, react-pdf's
  // defaults apply (wrap=true, fixed=false).
  wrap?: boolean;
  fixed?: boolean;
}) {
  return (
    <View
      wrap={wrap}
      fixed={fixed}
      style={{
        padding: "4px",
        display: "flex",
        width: "100%",
        flexDirection: "row",
        borderBottom: last ? "none" : tableBorder,
        ...style,
      }}
    >
      {children}
    </View>
  );
}

export function Table({
  children,
  style,
  wrap = false,
  minPresenceAhead,
}: {
  children: React.ReactNode;
  style?: any;
  wrap?: boolean;
  minPresenceAhead?: number;
}) {
  return (
    <View
      style={{
        border: tableBorder,
        ...style,
      }}
      wrap={wrap}
      minPresenceAhead={minPresenceAhead}
    >
      {children}
    </View>
  );
}

export function ContentRow({
  label,
  content,
  last = false,
  style,
}: {
  label: any;
  content?: any;
  last?: boolean;
  style?: any;
}) {
  return (
    <Row
      last={last}
      // Each content row is atomic: if it doesn't fit on the current page, the
      // whole row (label + content) moves to the next page. Avoids the case
      // where the label sits at the bottom of one page and its values appear
      // alone at the top of the next.
      wrap={false}
      style={{
        padding: "0 4px",
        ...style,
      }}
    >
      <SmallTextPDF
        style={{
          width: "30%",
          paddingRight: "4px",
        }}
      >
        {label}:
      </SmallTextPDF>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: "70%",
        }}
      >
        {content}
      </View>
    </Row>
  );
}
